import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'
import NotFound from '@/views/404.vue'

const routes = [
  {
    path: '/',
    component: () => import('@/views/Home.vue')
  },
  {
    path: '/login',
    component: () => import('@/views/Login.vue')
  },
  {
    name: 'Campaign',
    path: '/campaign/:id',
    props: true,
    component: () => import('@/views/Campaign.vue')
  },
  // {
  //   path: '/confirm',
  //   component: () => import('@/views/Confirm.vue')
  // },
  {
    path: '/reset-password',
    component: () => import('@/views/Reset.vue')
  },
  {
    path: '/recovery',
    component: () => import('@/views/Recovery.vue')
  },
  { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(async (to, from, next) => {
  await store.commit('initializeStore')
  const loggedIn = store.state.user

  if (loggedIn) {
    await store.dispatch('getUser')
    await store.dispatch('getAgreements')
  }
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = [
    '/login',
    '/recovery',
    '/reset-password',
    '/reset-password/'
  ]
  const authRequired = !publicPages.includes(to.path)

  // console.log('---Router guard:', {
  //   path: to.path,
  //   fullPath: to.fullPath,
  //   query: to.query,
  //   loggedIn: !!loggedIn,
  //   authRequired: !publicPages.includes(to.path)
  // })

  // console.log('I AM THE ROUTER GUARD', authRequired, loggedIn)
  if (authRequired && !loggedIn) {
    console.log('---Redirecting to login:', { authRequired, loggedIn, path: to.path })
    return next('/login')
  }

  console.log('---Proceeding to destination:', to.path)
  next()
})
export default router
